import {
  ROUTE_COMPANY_SETTINGS,
  ROUTE_COMPANY_SETTINGS_GENERAL,
  ROUTE_COMPANY_SETTINGS_NOTIFICATIONS,
  ROUTE_COMPANY_SETTINGS_APPEARANCE,
} from './routeNames'

import CompanySettingsView from '@/components/company_settings/CompanySettingsView.vue'

const CompanySettingsGeneralView = () =>
  import('@/components/company_settings/CompanySettingsGeneralView.vue')

const CompanySettingsNotificationsView = () =>
  import('@/components/company_settings/CompanySettingsNotificationsView.vue')

const CompanySettingsAppearanceView = () =>
  import('@/components/company_settings/CompanySettingsAppearanceView.vue')

const companySettingsRoutes = [
  {
    name: ROUTE_COMPANY_SETTINGS,
    path: '/company-settings',
    component: CompanySettingsView,
    redirect: { name: ROUTE_COMPANY_SETTINGS_GENERAL },
    meta: { resource: 'CompanySettings' },
    children: [
      {
        name: ROUTE_COMPANY_SETTINGS_GENERAL,
        path: '',
        component: CompanySettingsGeneralView,
        meta: { resource: 'CompanySettings' },
      },
      {
        name: ROUTE_COMPANY_SETTINGS_NOTIFICATIONS,
        path: 'notifications',
        component: CompanySettingsNotificationsView,
        meta: { resource: 'CompanySettings' },
      },
      {
        name: ROUTE_COMPANY_SETTINGS_APPEARANCE,
        path: 'appearance',
        component: CompanySettingsAppearanceView,
        meta: { resource: 'CompanySettings' },
      },
    ],
  },
]

export default companySettingsRoutes
